/**
 * Top-level writing surface mode. This is the stored session value; chrome and
 * editor behavior branch on it rather than on separate Focus / Reading flags.
 *
 * - `editor`: normal Writing (full chrome, comments on)
 * - `focus`: Focus mode (chrome stripped, no comment UI)
 * - `reading`: read-only, comments off (public share read)
 * - `readingComments`: read-only, comments on (owner Reading / comment invite)
 */
export type DisplayMode = "editor" | "focus" | "reading" | "readingComments";

export function displayModeIsReading(mode: DisplayMode): boolean {
  return mode === "reading" || mode === "readingComments";
}

/** Comment margin, amber highlights, Add comment affordances. */
export function displayModeAllowsComments(mode: DisplayMode): boolean {
  return mode === "editor" || mode === "readingComments";
}

/** Format ribbon / peeks / Harper. Writing only. */
export function displayModeIsWriting(mode: DisplayMode): boolean {
  return mode === "editor";
}

/** Map a share ACL role onto the surface mode (#100+). */
export function displayModeForShareRole(
  role: "read" | "comment" | "edit",
): DisplayMode {
  if (role === "read") return "reading";
  // Comment invites (and edit-on-reader until #102) keep prose read-only
  // with the comment layer on.
  return "readingComments";
}
